import {
  CentralReservationOfficeUserListItemDto,
  UnitAssignmentListItem,
} from '@ac/library-api';
import { isDefined } from '@ac/library-utils/dist/utils';

export interface UserUnitsDetails {
  isSingleCroUser: boolean;
  isMultiCroUser: boolean;
  isSinglePropertyUser: boolean;
  isMultiPropertyUser: boolean;
  isUserWithoutProperties: boolean;
  isUserWithoutCroUnits: boolean;
}

export const getUserUnitsDetails = (
  units?: UnitAssignmentListItem[],
  croUnits?: CentralReservationOfficeUserListItemDto[]
): UserUnitsDetails => {
  return {
    isSingleCroUser: isDefined(croUnits) && croUnits.length === 1,
    isMultiCroUser: isDefined(croUnits) && croUnits.length > 1,
    isSinglePropertyUser: isDefined(units) && units.length === 1,
    isMultiPropertyUser: isDefined(units) && units.length > 1,
    isUserWithoutProperties: !isDefined(units) || !units.length,
    isUserWithoutCroUnits: !isDefined(croUnits) || !croUnits.length,
  };
};
